var $ = jQuery;

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);

});

$(document).on('click', 'a[href^="/#"]', function (event) {
    if (window.location.pathname == '/') {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href').replace('/', '')).offset().top
        }, 500);
    }
});

$(document).on('click', 'a[href^="https://api-privatelease"],a[href^="http://api-privatelease"]', function (event) {
    if (window.global_tracking !== null && typeof window.global_tracking !== 'undefined') {
        let href = new URL($(this).attr('href'));
        href.searchParams.set('t', window.global_tracking);
        $(this).attr('href', href.toString());
    }
});


// User chat integration
window.civchat = {
    apiKey: 'gtbfaF',
};
const widgetUrl = 'https://private-lease-aanbiedingen.user.com/widget.js'

$('#pvl-chat-toggle').click(function () {
    loadChat();
});

function loadChat() {
    
    if (window.userEngageScript) {
        toggleChat();
    } else {
        $('#pvl-chat-toggle').addClass('loading');
        $('#pvl-chat-toggle > .loader').removeAttr("style");

        window.userEngageScript = document.createElement("script");
        window.userEngageScript.src = widgetUrl;
        
        document.body.appendChild(window.userEngageScript);


        window.userEngageScript.addEventListener("load", function () {
            setTimeout(function () {
                $('#pvl-chat-toggle').removeClass('loading');
                setTimeout(function () {
                    openChat();
                }, 150);
            }, 2200);
        }, false);
    }
}

function toggleChat() {
    if ($('#ue_widget').hasClass('active') && $('#ue_messenger').hasClass('ue_messengerHeaderOpen')) {
        closeChat();
    } else {
        openChat();
    }
}

function openChat() {
    userengage('widget.show');
    userengage('widget.open');
    $('#ue_widget').addClass('active');
}

function closeChat() {
    userengage('widget.close');
    $('#ue_widget').removeClass('active');
}